import { Component, Input, Output, HostBinding, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from 'lodash';


@Component({
  moduleId: module.id,
  selector: 'image-renderer',
  templateUrl: 'image-renderer.component.html',
  styleUrls: ['image-renderer.component.scss'],
})
export class ImageRendererComponent {
  @Input() row: any;
  @Input() small: boolean = false;
  @Input() column: any;

  @Output() linkClick = new EventEmitter<any>();

  @HostBinding('class.link-image')
  get isLink(): boolean {
    return _.get(this.column, 'link', false);
  }

  constructor(private sanitizer: DomSanitizer) {}

  get backgroundImage() {
    return this.sanitizer.bypassSecurityTrustStyle(`url("${(this.row.thumbnail)}")`);
  }

  onLinkClick() {
    this.linkClick.emit({column: this.column, row: this.row});
  }
}
